export const ROOT: string = '/';
export const INTERACTIVE: string = '/interactive';
export const ABOUT: string = '/about';
export const GALLERY: string = '/gallery';
export const VIDEO_AND_AUDIO: string = '/videoandaudio';
export const LEARNING: string = '/learning';
export const RESEARCH: string = '/research';
export const NEWS: string = '/news';
